import React, { useState, useEffect } from 'react';
import SliderProductsContainer from 'containers/SliderProducts';
import PropTypes from 'prop-types';
import CMSFactory from "factories/CMS";
import WrapperOptimizer from 'components/WrapperOptimizer';
import style from './style.scss'; //NOSONAR

let arrayTabs = [];

const ShelfTabSlider = (props) => {
    let dateServer = '';
    const [tab, setTab] = useState(1);
    const [tabsArray, setTabsArray] = useState([]);
    const [propsRender, setPropsRender] = useState(props);

    const setRenderTabs = (props) => {
        dateServer = props.date ? props.date : '';

        let shelfTab = props.data ? props.data.shelf_slider : [];

        arrayTabs = shelfTab.map((data) => {
            let serverDate = dateServer;
            let startDate = data.start_date ? CMSFactory.milliseconds(data.start_date) : '';
            let endDate = data.end_date ? CMSFactory.milliseconds(data.end_date) : '';
            if (startDate && (startDate >= serverDate)) return false;
            if (endDate && (endDate <= serverDate)) return false;
            if (data.active !== true) return false;
            if (!data.id) return false;

            return data;
        }).filter(Boolean).slice(0, 3);


        setTab(Math.trunc(arrayTabs.length / 2));
        setTabsArray(arrayTabs);
        setPropsRender(null);
    }

    if(propsRender) setRenderTabs(propsRender)
    
    useEffect(() => {
        setRenderTabs(props)
    }, []);

    const change = (value) => {
        setTab(value);
    }
    const notProducts = (value, i) => {
        if(!value && tabsArray && tabsArray.length){
            let _tabs = [...tabsArray];
            _tabs.splice(i, 1);
            setTabsArray(_tabs);
        }
    }
    return (
        <div className="shelf-tab-slider">
            <div className="center-tabs">
                <div className="container-title-destacados">
                    <span className="title-destacados">Destacados</span>
                </div>
                <div className="tabs-title-slider">
                    {tabsArray.map((data, i) => {
                        return (
                            <span key={i} className={"tabs-title-container" + (tab === i ? ' active' : '') + (' active-' + tab)}>
                                <div className={'tab-title mobile-click' + (tab === i ? ' active' : '')} key={i} onClick={() => change(i)}>{data.title}</div>
                                <i>●</i>
                            </span>)
                    })}
                </div>
            </div>
            {tabsArray.map((data, i) => {
                return (
                    <div key={i} className={'tab-slider' + (tab === i ? ' active' : '')}>
                        <WrapperOptimizer typeComponent="home_sliders_products">
                            {(dataWrapper) => {
                                return <SliderProductsContainer options={{ collections: 'H:' + data.id, position: i }} listTitle={'Vitrina ' + props.data.shelfIsland + ' - ' + props.data.shelf_slider[i].title} tab={tab} callbackNotProducts={(value) => notProducts(value, i)} campaignData={dataWrapper}/>
                            }}
                        </WrapperOptimizer>
                    </div>)
            })}
        </div>
    )
}


ShelfTabSlider.propTypes = {
    data: PropTypes.object,
    date: PropTypes.number
};

export default ShelfTabSlider;
